import React from 'react';

  import Header from '../../Components/Header';
  
  import Sidebar from '../../Components/Sidebar';
  
  import PageHeader from '../../Components/PageHeader';
  
  import Table from '../../Components/Table/Table';
  
  import axios from 'axios';
  
  export default function GrapeHarvestYears() {
    const [grapeHarvestYearsTable, setGrapeHarvestYearsTable] = React.useState(null);
    // ...
    React.useEffect(() => {
      axios.get(`${process.env.REACT_APP_API_URL}/grapeHarvestYears`).then((response) => {
        setGrapeHarvestYearsTable(response.data);  
      });  
    }, []);
    // ...
    const columns = React.useMemo(
      () => [
        {
          Header: 'Ano de Colheita',
          accessor: 'anoColheita',
        },
        {
          Header: 'Ações',
          accessor: 'id',
  
          Cell: (row: any) => {
            const editItem = (value: any) => {
                   window.location.href = `/grape-harvest-years/edit/${row.value}`
            };
            const deleteItem = () => {
              axios.delete(`${process.env.REACT_APP_API_URL}/grapeHarvestYears/${row.value}/`).then((res) => {
                if (res.data) {
                  window.location.href = '/grape-harvest-years';
                }
              });
            };
            return (
              <div>
  
                <button
                  onClick={editItem}
                  className="bg-dark-1 hover:bg-dark-2 text-white font-semibold hover:text-white py-2 px-4 border border-blue-500 hover:border-transparent rounded mr-4"
                >
                  Editar
                </button>
                <button
                  onClick={deleteItem}
                  className="bg-dark-1 hover:bg-dark-2 text-white font-semibold hover:text-white py-2 px-4 border border-blue-500 hover:border-transparent rounded mr-4"
                >
                  Excluir
                </button>
              </div>
            );
          },
        },
      ],
      [],
    );
  
    return (
      <div className="flex">
        <Sidebar />
        <div className="content">
          <Header />
          <PageHeader
            title="Lista de Anos de Colheita"
            RigthActionButtonTitle="Incluir Novo(a) Ano de Colheita"
            RigthActionButtonRoute={'/grape-harvest-years/create'}
          />
          <div className="mt-8">
            {grapeHarvestYearsTable ? <Table columns={columns} data={grapeHarvestYearsTable} /> : null}
          </div>
        </div>
      </div>
    );
  }
  
  